import DiscountTimeList from '@/views/discount/discount-time-list.vue';
import DiscountTimeDetail from '@/views/discount/discount-time-detail.vue';
import DiscountGoodsList from '@/views/discount/discount-goods-list.vue';
import DiscountAddGoods from '@/views/discount/discount-add-goods.vue';

//团购
import TeamGoodsList from '@/views/team/team-goods-list.vue';


export default [
    {
        path: '/discount/discount-time-list',
        component: DiscountTimeList,
        name: 'discountTimeList'
    },
    {
        path: '/discount/discount-time-detail',
        component: DiscountTimeDetail,
        name: 'discountTimeDetail'
    },
    {
        path: '/discount/discount-goods-list',
        component: DiscountGoodsList,
        name: 'discountGoodsList'
    },
    {
        path: '/discount/discount-add-goods',
        component: DiscountAddGoods,
        name: 'discountAddGoods'
    },
//团购
    {
        path: '/team/team-goods-list',
        component: TeamGoodsList,
        name: 'teamGoodsList'
    },
]